import { useGetAllSegments } from '@/hooks/data/masterDataHook';

import { Select, SelectProps } from 'antd';
import React from 'react';

interface Props extends SelectProps<any> {
  baseTripId?: string | null | undefined;
}

export default function SegmentInput({ baseTripId, ...props }: Props) {
  const { data, isLoading } = useGetAllSegments(baseTripId);
  return (
    <Select
      loading={isLoading}
      maxTagCount="responsive"
      allowClear
      {...props}
      filterOption={(input, option) => {
        return (option?.children as any)?.toLowerCase().includes(input.toLowerCase());
      }}
      showSearch={true}
    >
      {data?.map(c => {
        return (
          <Select.Option key={c.id} value={c.id}>
            {`${c.sourceStation} -> ${c.destinationStation}`}
          </Select.Option>
        );
      })}
    </Select>
  );
}
